import React, { FC } from 'react';
import Typography from '../../../components/Typography';

interface CardInterface {
  title: string;
  body: string;
  img: string;
  alt: string;
}

const Card: FC<CardInterface> = (props) => {
  return (
    <div className="rounded-tl-[7rem] rounded-tr-lg rounded-br-lg rounded-bl-lg bg-primary-light pl-12 pb-12 pr-8 pt-12 text-neutral-lightest h-72 w-56">
      <div className="h-48 flex flex-col gap-2">
        <div>
          <img src={props.img} alt={props.alt} />
        </div>

        <Typography variant="subtitle1">{props.title}</Typography>
        <Typography variant="body2">{props.body}</Typography>
      </div>
    </div>
  );
};

export default Card;
